"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 * no description
 */
class UtilsApi extends runtime.BaseAPI {
    /**
     * It takes in a token and returns a boolean if its still active. If the token is still active, then extend the token\'s expiration.
     */
    async checkTokenExpirationRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/utils/check_token_expiration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.TokenBodyToJSON(requestParameters.tokenBody),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CheckTokenExpirationResponseFromJSON(jsonValue));
    }
    /**
     * It takes in a token and returns a boolean if its still active. If the token is still active, then extend the token\'s expiration.
     */
    async checkTokenExpiration(requestParameters) {
        const response = await this.checkTokenExpirationRaw(requestParameters);
        return await response.value();
    }
    /**
     * deletes a token
     */
    async deleteTokenRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/utils/delete_token`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.TokenBodyToJSON(requestParameters.tokenBody),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * deletes a token
     */
    async deleteToken(requestParameters) {
        await this.deleteTokenRaw(requestParameters);
    }
    /**
     * Should always return a status code of 200. Used to determine if the server is up and working.
     */
    async healthRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/utils/health`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Should always return a status code of 200. Used to determine if the server is up and working.
     */
    async health() {
        await this.healthRaw();
    }
    /**
     * A safe public API to initialize the server. This API is sustainable to even if compromised, it will not cause problems.
     */
    async initRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/utils/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * A safe public API to initialize the server. This API is sustainable to even if compromised, it will not cause problems.
     */
    async init() {
        await this.initRaw();
    }
    /**
     * Finds what version of the app you are using
     */
    async versionRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/utils/version`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.VersionResponseFromJSON(jsonValue));
    }
    /**
     * Finds what version of the app you are using
     */
    async version() {
        const response = await this.versionRaw();
        return await response.value();
    }
}
exports.UtilsApi = UtilsApi;
